    
<template v-hammer:swipe.right="toggleSidebar">
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-image="backgroundImage"
    :style="sidebarStyle"
  >
    <div class="logo">
      <a href="/">
        <img :src="imgLogo" alt="logo" style="height: 70px" />
      </a>
      <div @click="close" class="close-btn">
        <md-icon class="close-icon"> close</md-icon>
      </div>
    </div>
    <div class="sidebar-wrapper" style="height: auto">
      <slot name="content"></slot>
      <md-list class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :to="link.path"
            :link="link"
          ></sidebar-link>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
import SidebarLink from "./SidebarLink.vue";

export default {
  components: {
    SidebarLink
  },
  props: {
    title: {
      type: String,
      default: "Vue MD"
    },
    backgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar.jpg")
    },
    imgLogo: {
      type: String,
      default: require("@/assets/img/logorealtec.png")
    },
    activeColor: {
      type: String,
      default: "green",
      validator: value => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    close() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      };
    }
  }
};
</script>
<style>


@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
.logo {
  padding: 15px 25px !important;
  background: #f9f9f9de !important;
  margin: 17px !important;
  border-radius: 3px !important;
}
.close-btn {
  position: absolute;
  right: -5px;
  top: -5px;
  color: #333;
  background: #2a5377;
  padding: 10px;
  border-radius: 100%;
}
</style>
